"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _react = require('react');





// What the search window leaves behind when it closes, kept in
// memory for this tab only:
// - the last search, so "Back to results" reopens the same list without
//   searching again;
// - the message a result opened, with the words searched, so the thread can
//   mark them and show the "Back to results" pill.
// The in-chat search pane sets the same hit when it steps through results.






















let state = { snapshot: null, hit: null }
const listeners = new Set()
const openers = new Set()

const set = (next) => {
  state = { ...state, ...next }
  listeners.forEach(listener => listener())
}

const subscribe = (listener) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

 const searchSession = {
  get: () => state,
  rememberSearch: (snapshot) => set({ snapshot }),
  setHit: (hit) => set({ hit }),
  // The app shell registers how to open the search window.
  onOpenRequest: (open) => {
    openers.add(open)
    return () => { openers.delete(open) }
  },
  // A fresh search (the inbox list's search field).
  open: () => openers.forEach(open => open(false)),
  // "Back to results": the last search as it was left.
  reopen: () => openers.forEach(open => open(true)),
}; exports.searchSession = searchSession

const getHit = () => state.hit

 const useSearchHit = () => _react.useSyncExternalStore.call(void 0, subscribe, getHit, getHit); exports.useSearchHit = useSearchHit
